<script setup lang="ts">
import { t } from '@satch-ui/translations/translations'

import { ShoppingCartIcon } from '@fond-of/satch-icons'
import { vE2eTestId } from '@fond-of/telemetry'
</script>

<template>
  <div
    v-e2e-test-id="'emptyFloatingCart'"
    class="font-sans-bold flex h-[15.75rem] w-full flex-col items-center justify-center text-base text-black lg:h-[17.875rem]"
  >
    <ShoppingCartIcon class="mb-[1.563rem] size-16 md:mb-5" />

    {{ t('cart.empty') }}
  </div>
</template>
